module.exports = __webpack_public_path__ + "img/dashboard-load.8c1059a4.svg";